export enum AsyncOperationState {
  IDLE,
  IN_PROGRESS,
  DONE,
  ERRORED,
}
